import {
    RequestKeys,
} from 'app/hooks/useRequest'

import ChangeHistory from 'app/shared-components/ChangeHistory'

import request from 'app/requests/Container/Damage.requests'

const DamageChangeHistory = ({
    id,
}: { id: number }) => {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getDamageModifications}
            config={request.modifications}
            configName="DamageChangeHistoryTable"
            name="DamageChangeHistory"
            labelPrefixForChangedColumn={['Damages']}
        />
    )
}

export default DamageChangeHistory
